import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
import {
    parseStatus
} from "@/util/util";
import {
    baseUrl
} from '@/config/env';


export const formTypeOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: true,
    editBtn: true,
    delBtn: false,
    columnBtn: false,
    viewBtn: true,
    menuWidth: '300',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "类型名称",
            search: true,
            prop: "typeName",
            type: 'input',
            addVisdiplay: true,
            editVisdiplay: true
        },
        {
            label: "类型编码",
            prop: "typeCode",
            type: "input",
            // dicData: DIC.FORM_TYPE,
            search: true,
            addVisdiplay: true,
            editVisdiplay: true
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "创建人",
            prop: "createBy",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
    ]
};